import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1be69662"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value"]
const _hoisted_2 = { key: 1 }

import {ref, onMounted, onUnmounted, computed} from 'vue'
import { useRouter } from 'vue-router'
import { openPopCinemaSearch } from '@remote/utils/dialog'
import {useCinemaSearch, addHistoryLocalCache} from '@remote/store/cinemaSearch'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { data, setSearchPhase } = useCinemaSearch()
const router = useRouter()
const inputRef = ref<HTMLInputElement>()

const isVisibleInput = computed(() => router.currentRoute.value.name === 'cinemaSearch')

const handleOnOpenSearchPanel = () => {
  if (router.currentRoute.value.name === 'cinema') openPopCinemaSearch({})
}

const handleOnSearchResource = () => {
  const name = inputRef?.value?.value
  if (name) {
    addHistoryLocalCache(name)
    setSearchPhase(name, 'all')
    setSearchPhase(name, 'movie')
    setSearchPhase(name, 'tv')
    setSearchPhase(name, 'other')
  }
}

const handleOnEnter = (e) => {
  if (e.keyCode==13) handleOnSearchResource()
}

onMounted(() => {
  window.document.addEventListener('keydown', handleOnEnter)
})

onUnmounted (() => {
  window.document.removeEventListener('keydown', handleOnEnter)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "hezi-search-box",
    onClick: handleOnOpenSearchPanel
  }, [
    (_unref(isVisibleInput))
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          ref_key: "inputRef",
          ref: inputRef,
          placeholder: "请输入影片名称",
          value: _unref(data).phase
        }, null, 8, _hoisted_1))
      : (_openBlock(), _createElementBlock("p", _hoisted_2, " 请输入影片名称 ")),
    _createElementVNode("i", {
      class: "icomoon-Search",
      onClick: handleOnSearchResource
    })
  ]))
}
}

})